import { clientApi } from './CLIENT';

const url = '/api/dashboard/auth/registration';
// eslint-disable-next-line no-return-await
export default async (body) => await clientApi().post(url, JSON.stringify(body));
